<template>
    <v-container>
        <v-form ref="form">
            <v-row>
                <v-col cols="12">
                    <h2 class="headline font-weight-bold mb-3">
                    Crie o seu Chá 
                    </h2>
                    <v-text-field :rules="[rules.required]" v-model="mamae" label="Nome da Mamãe *"/>
                    <v-text-field v-model="papai" label="Nome do Papai"/>        
                    <v-text-field type="email" :rules="[rules.required, rules.validEmail]" v-model="email" label="E-Mail do(a) Organizador(a) *"/>
                    <Address v-model="endereco" @closeAddress="endereco = $event"/>               
                    <!-- <v-text-field v-model="endereco" label="Endereço para Entrega dos Presentes"/> -->
                    <v-text-field :rules="[rules.required]" v-model="dataRevela" type="datetime-local" label="Data e Hora da Revelação * "/>   
                    <v-radio-group :rules="[rules.required]" v-model="revelaType" row label="Tipo de Revelação">
                        <v-radio key="CV" label="Chamada de Vídeo" value="CV"></v-radio>
                        <v-radio key="FS" label="Fundo do Site" value="FS"></v-radio>
                    </v-radio-group>  

                    <v-radio-group :rules="[rules.required]" v-model="sexo" row label="Selecione o Sexo do Bebê: ">
                        <v-radio key="NS" label="Ainda Não Sei" value= "NS" color="green"></v-radio>
                        <v-radio key="M" label="Menino" value="M"></v-radio>
                        <v-radio key="F" label="Menina" value="F" color="pink"></v-radio>
                    </v-radio-group>  
                    <v-text-field :rules="[rules.required]" v-model="nomeMenino" label="Nome para Menino *"/> 
                    <v-text-field :rules="[rules.required]" v-model="nomeMenina" label="Nome para Menina *"/>
                                   
                    <vue-recaptcha
                        ref="recaptcha"
                        @verify="onVerify"
                        @expired="onExpired"
                        :loadRecaptchaScript="true"
                        sitekey="6LeQ47EZAAAAAMWpaI0xQRpxgNooOKlXdVPMPzS5">
                    </vue-recaptcha>
                </v-col>
                <v-col cols="12" class="text-right">
            <v-divider/>
                <v-btn v-if="verificado == true" :loading="loading" outlined class="ma-2 white--text" color="primary" @click="saveInfo">
                    <v-icon left dark>mdi-plus</v-icon>
                    Criar meu Chá
                </v-btn>  
                <v-btn v-else outlined class="ma-2 white--text" color="primary" @click="saveInfo" disabled>
                    <v-icon left dark>mdi-plus</v-icon>
                    Criar meu Chá
                </v-btn>                                          
                </v-col>
            </v-row>   
        </v-form>          
    </v-container>
</template>
<script>
import { db } from '@/main'
import VueRecaptcha from 'vue-recaptcha';
import Address from '@/components/componentAddress';
// import {firstMail} from '@/modelos/modelosEmails';
export default {
    components: { VueRecaptcha, Address},
    data(){
        return{
            rules: {
                required: value => !!value || 'Campo Obrigatório.', 
                validEmail: v => /.+@.+\..+/.test(v) || 'E-mail inválido',               
            },            
            mamae : '',
            papai : '',
            endereco : '',
            dataRevela: '',
            nomeMenina: '',
            nomeMenino: '',
            sexo: 'NS',
            logo: 'https://lh3.googleusercontent.com/proxy/e1d_K6x2AZizO_zWnOCD39K9Nmt29S7gMonduHHdJuk21g7ORVBrKpeQ8HgEbO4TMIAMsdl4doMq9jamNVSo4rhC',
            contagem: 0,
            verificado: false,
            loading: false,
            revelaType: 'FS',
            email: '',
        }
    },
    methods: {
        getURL(){
            let URL = ''
            let dtAtual = new Date().getTime()

            if (this.nomeMenina != '')
            URL = this.nomeMenina.substring(0,1)
            if (this.nomeMenino != '')
            URL = URL + this.nomeMenino.substring(0,1)
            if (this.mamae != '')
            URL = URL + this.mamae.substring(0,1)         
            if (this.papai != '')
            URL = URL + this.papai.substring(0,1)
            if (this.nomeMenina != '')
            URL = URL + this.nomeMenina.substring(2,3)
            if (this.nomeMenino != '')
            URL = URL + this.nomeMenino.substring(1,2)
                    
            dtAtual = dtAtual.toString()
            URL = URL + '-' + dtAtual.substring(dtAtual.length - 4, dtAtual.length)
            return URL.toUpperCase()        
        },
        saveInfo(){
            if (this.$refs.form.validate()) {
                this.loading = true
                let dadosCha = {
                    nomeMamae: this.mamae,
                    nomePapai:  this.papai, 
                    endereco: this.endereco,
                    dataRevelacao: new Date(this.dataRevela).getTime(),
                    nomeMenina: this.nomeMenina,
                    nomeMenino: this.nomeMenino, 
                    email: this.email,
                    votosMenino: 0,
                    votosMenina: 0,
                    sexo: this.sexo,
                    chaveDeAcesso: this.makeid(8), 
                    URL: this.getURL(),
                    tipoRevelacao: this.revelaType,
                    encerrado: false,
                }

                db.collection('revelacoes').add(dadosCha).then(async() => {
                    this.loading = false
                    sessionStorage.setItem("newCad",true);
                    this.$router.replace('/success/'+dadosCha.URL)
                    db.collection('messageSend').add({
                        template: {
                            name: 'cadastro',
                            data: {
                                accessCode: dadosCha.URL,
                                keyCode: dadosCha.chaveDeAcesso,
                                revelationURL: 'https://www.revelacha.com.br/access/'+dadosCha.URL
                            }
                        },
                        to: this.email,
                        bcc: 'lincoln19922@gmail.com'
                    })
                }).catch(function (error) {
                    console.error('Error to Create Chá: ' + error)
                })            
            }
        },
        makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },        
        onSubmit: function () {
        this.$refs.invisibleRecaptcha.execute()
        },
        onVerify: function (response) {
        console.log('Verify: ' + response)
        this.verificado = true;
        },
        onExpired: function () {
            // console.log('Expired')
            this.verificado = false;

        },
        resetRecaptcha () {
        this.$refs.recaptcha.reset() // Direct call reset method
        }
    }      
    
}
</script>